import React from "react";
import { Col, Row } from "antd";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import NewBox from "../../Account/NewBox";
import { getprofile } from "../../../Redux/AllApi/action";

// NOTE: removed framer-motion import

export default function Boxes3() {
  const navigate = useNavigate();
  const deshboard = useSelector((state) =>
    state?.allapi?.deshboard ? state?.allapi?.deshboard : {}
  );
  const get_profile = useSelector((state) =>
    state?.allapi?.get_profile ? state?.allapi?.get_profile : {}
  );

  const totalIncome =
    (deshboard?.bounseIncomes || 0) +
    (deshboard?.directincome || 0) +
    (deshboard?.gapingIncomes || 0) +
    (deshboard?.lavelIncomes || 0) +
    (deshboard?.matchingIncomes || 0) +
    (deshboard?.reMatchingIncomes || 0) +
    (deshboard?.redirectincome || 0);

  // Reusable box renderer (adds box-3d class)
  const RenderBox = ({ value, label, onClick, className = "" }) => (
    <Col lg={6} md={12} sm={12} xs={12}>
      <div
        className={`box-3d relative m-5 cursor-pointer rounded-2xl p-6 shadow-lg ${className}`}
        style={{ transformStyle: "preserve-3d", perspective: 1200 }}
        onClick={onClick}
      >
        <div
          className="box-3d-inner w-full h-full rounded-xl p-4"
        /* inner card — translateZ applied on hover via CSS */
        >
          {/* <div className="flex justify-between items-center"> */}
          <div className="text-center font-sembold">
            <div className="text-3xl font-semibold boxHeading text-color-deshboard">{value}</div>
          </div>
          {/* <div className="flex justify-end items-center mt-3"> */}
          <div className="text-center font-sembold mt-3">
            <div className="text-sm dashbordTextnew text-color-deshboard">{label}</div>
          </div>
        </div>
      </div>
    </Col>
  );

  return (
    <>
      <Row>
        <NewBox />
      </Row>

      <Row gutter={[0, 20]} className="px-2 mb-3">
        <RenderBox
          value={deshboard?.DirectTeam || 0}
          label="Direct Team"
          onClick={() => navigate("/accounts/direct-team")}
          className="flex1 p-10 userd userd3 m-5 cursor-pointer bg-gradient-1"
        />

        <RenderBox
          value={deshboard?.allTeam2 || 0}
          label="Total Team"
          onClick={() => navigate("/accounts/total-team")}
          className="flex1 p-10 userd userd4 m-5 cursor-pointer bg-gradient-2"
        />

        {/* ===== BAND INCOMES KE BOX (abhi ke liye) =====
        <RenderBox
          value={deshboard?.directincome || 0}
          label="PR SP"
          onClick={() => navigate("/accounts/direct-income")}
          className="flex1 p-10 userd userd4 m-5 cursor-pointer bg-gradient-1"
        />

        <RenderBox
          value={deshboard?.bounseIncomes || 0}
          label="PB SP"
          onClick={() => navigate("/accounts/bonus-income")}
          className="flex1 p-10 userd userd1 m-5 cursor-pointer bg-gradient-2"
        />

        <RenderBox
          value={deshboard?.lavelIncomes || 0}
          label="GD SP"
          onClick={() => navigate("/accounts/level-income")}
          className="flex1 p-10 userd userd2 m-5 cursor-pointer bg-gradient-3"
        />

        <RenderBox
          value={deshboard?.matchingIncomes || 0}
          label="BMB SP"
          onClick={() => navigate("/accounts/matching-income")}
          className="flex1 p-10 userd userd5 m-5 cursor-pointer bg-gradient-4"
        />

        <RenderBox
          value={deshboard?.redirectincome || 0}
          label="RPR SP"
          onClick={() => navigate("/accounts/redirect-income")}
          className="flex1 p-10 userd userd6 m-5 cursor-pointer bg-gradient-7"
        />
        ===== BAND INCOMES KE BOX END ===== */}



        {/* ===== CLUB TEAM KE BOX BAND HAIN (abhi ke liye) =====
        <RenderBox
          value={get_profile?.lefttotalTeams || 0}
          label="L Club Team"
          className="flex1 p-10 userd userd1 m-5 cursor-pointer bg-gradient-7"
        />

        <RenderBox
          value={get_profile?.righttotalTeams || 0}
          label="R Club Team"
          className="flex1 p-10 userd userd2 m-5 cursor-pointer bg-gradient-7"
        />

        <RenderBox
          value={get_profile?.leftdireactTeams || 0}
          label="D L Club"
          className="flex1 p-10 userd userd5 m-5 cursor-pointer bg-gradient-7"
        />

        <RenderBox
          value={get_profile?.rightdireactTeams || 0}
          label="D R Club"
          className="flex1 p-10 userd userd6 m-5 cursor-pointer bg-gradient-7"
        />
        ===== CLUB TEAM KE BOX END ===== */}

        <RenderBox
          value={totalIncome || 0}
          label="Total SP"
          className="flex1 p-10 userd userd3 m-5 cursor-pointer bg-gradient-7"
        />

        {/* <RenderBox
          value={deshboard?.gapingIncomes || 0}
          label="Gapping Income"
          onClick={() => navigate("/accounts/relevel-income")}
          className="flex1 p-10 userd userd7 m-5 cursor-pointer bg-gradient-6"
        /> */}


        <RenderBox
          value={deshboard?.distibutorIncomes || 0}
          label="CP Income"
          onClick={() => navigate("/accounts/cp-income")}
          className="flex1 p-10 userd userd7 m-5 cursor-pointer bg-gradient-6"
        />


        {/* ===== BAND INCOMES KE BOX (abhi ke liye) =====
        <RenderBox
          value={deshboard?.gapingIncomes || 0}
          label="RRL SP"
          onClick={() => navigate("/accounts/rematching-income")}
          className="flex1 p-10 userd userd8 m-5 cursor-pointer bg-gradient-7 "
        />
        <RenderBox
          value={deshboard?.reMatchingIncomes || 0}
          label="RBM SP"
          onClick={() => navigate("/accounts/rematching-income")}
          className="flex1 p-10 userd userd8 m-5 cursor-pointer bg-gradient-7 "
        />
        ===== BAND INCOMES KE BOX END ===== */}

        <RenderBox
          value={get_profile?.moneyBackIncome || 0}
          label="Money Back"
          className="flex1 p-10 userd userd8 m-5 cursor-pointer bg-gradient-7 "
        />

        {/* <RenderBox
          value={getprofile?.businessGrowthBenefit || 0}
          label="RePurchase Reward"
          // onClick={() => navigate("/accounts/businessGrowthBenefit")}
          className="flex1 p-10 userd userd8 m-5 cursor-pointer bg-gradient-6 "
        /> */}

      </Row>




      <div className="d-flex justify-content-center" style={{ margin: "20px 0px 10px 0px" }}>
        <div className="mk-upgrade-3d-border">
          <img
            src="/img/channel_partner_hd.png"
            alt="upgradenow"
            className="mk-upgrade-img img-fluid rounded-0"
          />
        </div>
      </div>




      <Row gutter={[0, 20]} className="px-2 mb-5">

        {/* ===== DSR / FAW / CPP / REWARD / RGC / RENEWAL KE BOX BAND HAIN (abhi ke liye) =====
        <RenderBox
          value={deshboard?.retailsIncomes || 0}
          label="DSR SP"
          onClick={() => navigate("/accounts/retail-income")}
          className="flex1 p-10 userd userd8 m-5 cursor-pointer bg-gradient-10 "
        />
        ===== DSR SP BOX END ===== */}

        <RenderBox
          value={getprofile?.distibutorIncomes || 0}
          label="FAW SP"
          // onClick={() => navigate("/accounts/businessGrowthBenefit")}
          className="flex1 p-10 userd userd8 m-5 cursor-pointer bg-gradient-10 "
        />

        <RenderBox
          value={getprofile?.CppSpGolden || 0}
          label="CPP SP"
          // onClick={() => navigate("/accounts/businessGrowthBenefit")}
          className="flex1 p-10 userd userd8 m-5 cursor-pointer bg-gradient-10 "
        />

        {/* ===== REWARD BOX BAND HAI (abhi ke liye) =====
        <RenderBox
          value={getprofile?.Reward || 0}
          label="Reward"
          // onClick={() => navigate("/accounts/businessGrowthBenefit")}
          className="flex1 p-10 userd userd8 m-5 cursor-pointer bg-gradient-6 "
        />
        ===== REWARD BOX END ===== */}

        {/* ===== RGC BOX BAND HAI (abhi ke liye) =====
        <RenderBox
          value={getprofile?.RankGlobalClubIncome || 0}
          label="RGC SP"
          // onClick={() => navigate("/accounts/businessGrowthBenefit")}
          className="flex1 p-10 userd userd8 m-5 cursor-pointer bg-gradient-6 "
        />
        ===== RGC BOX END ===== */}

        {/* ===== RENEWAL BOX BAND HAI (abhi ke liye) =====
        <RenderBox
          value={getprofile?.RenewalIncome || 0}
          label="Renewal"
          // onClick={() => navigate("/accounts/businessGrowthBenefit")}
          className="flex1 p-10 userd userd8 m-5 cursor-pointer bg-gradient-6 "
        />
        ===== RENEWAL BOX END ===== */}



      </Row>
    </>
  );
}
